<template>
  <div>
    <!-- MOBILE: all/upcoming tabs -->
    <scroll-tabs-bar
      v-if="$store.state.isMobile && categories?.length"
      :items="categories"
      :selected-item="currentCategory"
      @selectitem="selectCategory"
      class="geoff-border-bottom competitons-wr"
    ></scroll-tabs-bar>

    <div class="row" :class="{'m-0': $store.state.isMobile}">
      <div class="col-3 mb-2" v-if="!$store.state.isMobile">
        <div class=" mx-2">
          <inplay-sidebar 
            :inplay-event="inplayEvents"
            :upcoming-events="upcomingEvents"
            :selected-inplay-event="selectedInplayEvent"
            @inplay-event-selected="inplayEventSelected"
          />
        </div>
      </div>
      <div class="col-9  px-0 " :class="{'col-12': $store.state.isMobile}">

        <!-- loading -->
        <template v-if="loading">
          <div  class="no-events-container">
            <pre-loader/> 
          </div>
        </template>
        
        <!-- no events -->
        <template v-else-if="isShowNoEvents">
          <div class="no-events-container">
            <no-events class="" :title="'In Play Events'">There are no live In Play events. For a live price please call 01344873334</no-events>
          </div>
        </template>

        <!-- events (main content) -->
        <template v-else>

          <!-- iplay: desktop - always; mobile - only tab  -->
          <template v-if="!$store.state.isMobile || ($store.state.isMobile && currentCategory === 'In Play')">
            <div  class="geoff-bg-section111" :class="{'rounded-3 me-3': !$store.state.isMobile}">
              <div class="mb-2 fw-600 fs-6 p-n sub-header geoff-bg-section rounded-3">In Play Events</div>
              <div>

                <transition-group name="flip-list" tag="div" class="position-relative">
                  <div 
                    class="inplay-event-wr" 
                    v-for="event in sortedInplayEvents" 
                    :key="`${event?.eventFile}${event?.eventGroup}`"
                  >
                    <match-event-full
                      class="event-container geoff-bg-section " 
                      :class="{'rounded-3': !$store.state.isMobile}"
                      :match-data="event" 
                      show-sport-logo/>
                  </div>
                </transition-group>

              </div>
            </div>
          </template>

          <!-- upcoming: desktop - never; mobile - only tab  -->
          <template v-if="$store.state.isMobile && currentCategory === 'Upcoming'">
            <inplay-upcoming-events-list :events="upcomingEvents"/>
          </template>

        </template>

      </div>

    </div>
  </div>
</template>

<script>
  import PreLoader from "@/components/UI/PreLoader";
  import NoEvents from "@/components/Sport/NoEvents";
  import ScrollTabsBar from "@/components/UI/ScrollTabsBar";
  import InplaySidebar from "@/components/Sport/Inplay/InplaySidebar";
  import MatchEventFull from "@/components/Sport/Competitions/MatchEventFull";
  import InplayUpcomingEventsList from "@/components/Sport/Inplay/InplayUpcomingEventsList";

  export default {
    name: "InplayMain",
    components: {
      NoEvents,
      PreLoader,
      ScrollTabsBar,
      InplaySidebar,
      MatchEventFull,
      InplayUpcomingEventsList,
    },
    data:()=>{
      return{
        loading: true,
        inplayEvents: [],
        upcomingEvents: [],
        currentCategory: null, // mobile: selected tab
        selectedInplayEvent: null, // desktop: selcted event to show in first position
        intervalLoad: null,
      }
    },
    computed:{
      categories() {
        let result = []
        if (this.inplayEvents?.length) {
          result.push('In Play')
        }
        if (this.upcomingEvents?.length) {
          result.push('Upcoming')
        }
        return result
      },

      sortedInplayEvents(){
        if (this.selectedInplayEvent){
          const selectedAvailable = this.inplayEvents.find(el => 
            el.eventGroup === this.selectedInplayEvent.eventGroup 
            && el.eventFile === this.selectedInplayEvent.eventFile
            && el.sportcode === this.selectedInplayEvent.sportcode
          )
          let sortedInplayEvent = this.inplayEvents
              .filter(ev => !(ev.eventGroup === this.selectedInplayEvent.eventGroup 
                  && ev.eventFile === this.selectedInplayEvent.eventFile
                  && ev.sportcode === this.selectedInplayEvent.sportcode)
              )

          if (selectedAvailable) {
            sortedInplayEvent.unshift(selectedAvailable)
          }
          return sortedInplayEvent
        } else {
          return this.inplayEvents
        }
      },

      isShowNoEvents() {
        return (!this.$store.state.isMobile && !this.inplayEvents?.length)  // desktop - check in play events
        || (this.$store.state.isMobile && !this.inplayEvents?.length && !this.upcomingEvents?.length) // mobile - check inplay and upcoming (because of tabs)
      }
    },

    beforeUnmount() {
      if (this.intervalLoad) clearInterval(this.intervalLoad)
    },
    mounted() {
      this.intervalLoad = setInterval(()=>this.loadData(), 5000)
      this.loadData()

    },

    methods:{
      loadData() {
        this.API.getInplayEvents() 
          .then(data => {
            // add svg icon to model
            this.inplayEvents = data?.inPlay?.map(el => {
              return {
                ...el,
                sportSvg: this.API.SPORTS.find(s => s.code === el.sportcode)?.svg
              }
            })
            
            this.upcomingEvents = data?.upcoming?.map(el => {
              return {
                ...el,
                sportSvg: this.API.SPORTS.find(s => s.code === el.sportcode)?.svg
              }
            })
            this.updateSelected()

          })
          .finally(() => {
            this.loading = false
          })
      },
      updateSelected() {
        // update tabs (mobile)
        if (this.categories?.length && !this.categories.includes(this.currentCategory)) {
            this.currentCategory = this.categories[0]
        }

        //update selected event
        if (this.inplayEvents?.length) {
          if (!this.selectedInplayEvent) {
            this.selectedInplayEvent = this.inplayEvents[0]
          }
          else {
            // validate if selected is available and reassign if not
            const selectedAvailable = this.inplayEvents.find(el => 
              el.eventGroup === this.selectedInplayEvent.eventGroup 
              && el.eventFile === this.selectedInplayEvent.eventFile
              && el.sportcode === this.selectedInplayEvent.sportcode
            )

            if (!selectedAvailable) {
              this.selectedInplayEvent = this.inplayEvents[0]
            }
            else {
              this.selectedInplayEvent = selectedAvailable
            }
          }
        }
        else {
          this.selectedInplayEvent = null
        }
        
      },
      selectCategory(categoryName){
        this.currentCategory = categoryName
      },
      inplayEventSelected(event) {
        this.selectedInplayEvent = event
      },
    
    }
  }
</script>

<style scoped lang="scss">
  .no-events-container {
      position: relative;
      width: 100%;
      min-height: 80vh;
  }

  .flip-list-move {
    transition: transform 0.3s;
  }

  .inplay-event-wr {
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0rem;
    }
  }
</style>